"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unicode = void 0;
var Unicode;
(function (Unicode) {
    Unicode["SPACE"] = "\u00A0";
})(Unicode = exports.Unicode || (exports.Unicode = {}));
